import isEmail from 'validator/lib/isEmail.js';

/**
 * Validates an email address against backend behavior.
 * Matches backend `class-validator` `@IsEmail()` behavior.
 *
 * Note: This helper trims the input before validating.
 */
export function isBackendCompatibleEmail(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  return isEmail(trimmed);
}
